import { render, staticRenderFns } from "./Obras_jornadas.vue?vue&type=template&id=53a0134b&"
import script from "./Obras_jornadas.vue?vue&type=script&lang=js&"
export * from "./Obras_jornadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports